import React from "react";

export default function FlightVerificationButton(props) {
  return (
    <button disabled className="hotelofferframe13 availabilitybuttonstandard ">
      verify/placeholder
    </button>
  );
}
